function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { superstructResolver } from '@hookform/resolvers/superstruct';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ButtonSave } from '@arc/frontend/ui-buttons';
import { InputTextFieldWithControl, PasswordInput } from '@arc/frontend/ui-form';
import { LoadingIndicator } from '@arc/frontend/ui-graphics';
import { su, typography } from '@arc/frontend/ui-theme';
import { useMutationLogin } from '@arc/frontend/util-auth';
import { LoginDto } from '@arc/shared/util-auth';
import { useResetPasswordModalListener } from './ResetPassword';
import { ResetPasswordModal } from './ResetPasswordModal';
const formSchema = LoginDto;
var _ref = process.env.NODE_ENV === "production" ? {
  name: "e4f4t6",
  styles: "display:grid;grid-template-columns:repeat(1, minmax(0, 1fr));grid-template-rows:repeat(3, minmax(0, 1fr))"
} : {
  name: "1558a51-LoginForm",
  styles: "display:grid;grid-template-columns:repeat(1, minmax(0, 1fr));grid-template-rows:repeat(3, minmax(0, 1fr));label:LoginForm;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "3p4igb",
  styles: "grid-row:span 1 / span 1"
} : {
  name: "393s9r-LoginForm",
  styles: "grid-row:span 1 / span 1;label:LoginForm;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref3 = process.env.NODE_ENV === "production" ? {
  name: "3p4igb",
  styles: "grid-row:span 1 / span 1"
} : {
  name: "393s9r-LoginForm",
  styles: "grid-row:span 1 / span 1;label:LoginForm;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref4 = process.env.NODE_ENV === "production" ? {
  name: "1rqvlth",
  styles: "display:flex;flex-direction:row;align-items:center;justify-content:space-between;grid-row:span 1 / span 1"
} : {
  name: "1aa7u13-LoginForm",
  styles: "display:flex;flex-direction:row;align-items:center;justify-content:space-between;grid-row:span 1 / span 1;label:LoginForm;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export function LoginForm() {
  const {
    t
  } = useTranslation('login');
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
  const {
    mutateAsync: requestLogin,
    isPending
  } = useMutationLogin();
  const formMethods = useForm({
    defaultValues: {
      email: '',
      password: ''
    },
    resolver: superstructResolver(formSchema, {
      coerce: true,
      mask: true
    })
  });
  const handleSubmit = formMethods.handleSubmit(async data => {
    await requestLogin(data);
  });
  useResetPasswordModalListener(setShowResetPasswordModal);
  const openResetPasswordModal = () => {
    setShowResetPasswordModal(true);
  };
  const closeResetPasswordModal = () => {
    setShowResetPasswordModal(false);
  };
  return <>
			<FormProvider {...formMethods}>
				<form onSubmit={handleSubmit} css={_ref}>
					<div css={_ref2}>
						<InputTextFieldWithControl name="email" label={t('form label Email')} placeholder={t('form placeholder Email')} autoFocus type="email" forceAutoComplete={true} disablePasswordManager={false} data-testid="email-input" useRandomName={false} />
					</div>
					<div css={_ref3}>
						<PasswordInput name="password" label={t('form label Password')} placeholder={t('form placeholder Password')} disablePasswordManager={false} forceAutoComplete={true} data-testid="password-input" />
					</div>
					<div css={_ref4}>
						<button css={[typography.clickableLink, su.textSm, "width:4rem;text-align:left;" + (process.env.NODE_ENV === "production" ? "" : ";label:LoginForm;")]}
          // Default type is submit, which we don't want for forgot password
          type="button" onClick={openResetPasswordModal}>
							{t('Forgot password')}
						</button>
						<ButtonSave type="submit" disabled={isPending}>
							{isPending ? <LoadingIndicator immediate={true} color="white" /> : t('action Log in')}
						</ButtonSave>
					</div>
				</form>
			</FormProvider>
			<ResetPasswordModal show={showResetPasswordModal} handleClose={closeResetPasswordModal} email={formMethods.watch('email')} />
		</>;
}